import { CASHBACK_FACTOR } from '../constants'

export default () => {
  return localStorage.getItem(CASHBACK_FACTOR);
}
